import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import BaseService from '../../BaseService'
import BerechtigteListService from '../../services/BerechtigteListService'
import VerbrauchsstaetteService from '../Verbrauchsstaette/VerbrauchsstaetteService'
import VerbrauchsstaetteDto from '../Verbrauchsstaette/VerbrauchsstaetteDto'
import VerbrauchsstaetteColumns from '../Verbrauchsstaette/VerbrauchsstaetteColumns'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/List/List.js'
import '@isceco/widget-library2/basic-elements/Filter/FilterGroup.js'
import '@isceco/widget-library2/basic-elements/Filter/StringFilter.js'
import '@isceco/widget-library2/basic-elements/Filter/MultiselectFilter.js'

export default class GPVerbrauchsstaette extends WebComponent {

  constructor() {
    super()
    this.verbrauchsstaetteService = new VerbrauchsstaetteService(getNavigationId())
    this.kantonService = new BaseService('kanton')
    this.ausnahmegruppeService = new BaseService('ausnahmegruppe')
  }

  get translationFile() {
    return './views/GPDetail/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.verbrauchsstaetteService.getBackendListUrl(),
      this.kantonService.list(),
      this.ausnahmegruppeService.list()
    ]).then(([url, kantone, ausnahmegruppen]) => {
      this.url = url
      this.kantone = kantone.map(kanton => ({value: kanton, name: kanton}))
      this.ausnahmegruppen = ausnahmegruppen.map(this._toAusnahmegruppeItem)
    }).catch(_ => {
      this.url = ''
      this.kantone = []
      this.ausnahmegruppen = []
    }).finally(() =>
      this.render()
    )
  }

  getTemplate() {
    return html`
      <isceco-title size="medium" text="${this.i18n.translate('gp.verbrauchsstaette.title')}"></isceco-title>
      <isceco-filter-group>
        <isceco-string-filter label="${this.i18n.translate('verbrauchsstaette.header.adresse')}"
                              key="adresse"
        ></isceco-string-filter>
        <isceco-multiselect-filter label="${this.i18n.translate('verbrauchsstaette.header.kanton')}"
                                   key="kanton"
                                   .items="${this.kantone}"
        ></isceco-multiselect-filter>
        <isceco-multiselect-filter label="${this.i18n.translate('verbrauchsstaette.header.ausnahmegruppe')}"
                                   key="ausnahmegruppe"
                                   .items="${this.ausnahmegruppen}"
        ></isceco-multiselect-filter>
        <isceco-string-filter label="${this.i18n.translate('verbrauchsstaette.header.messpunkten')}"
                              key="messpunkt"
        ></isceco-string-filter>
      </isceco-filter-group>
      <isceco-list url="${this.url}"
                   .listService="${BerechtigteListService}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this._toDTO}"
                   .columns="${VerbrauchsstaetteColumns.getColumns()}"
                   sort="name" order="asc"
      ></isceco-list>
    `
  }

  _toDTO = row => new VerbrauchsstaetteDto(row)
  _toAusnahmegruppeItem = json =>  ({ value: json, name: this.i18n.translate(`verbrauchsstaette.ausnahmegruppe.${json.toLowerCase()}`) })

}

customElements.define('eko-frontend-gp-detail-verbrauchsstaette', GPVerbrauchsstaette)
